import React, { useId } from 'react'
import { motion, Variants } from 'framer-motion'
import pencilTex from '@/icons/pensil_ellipse.svg'  // 연필 질감 이미지

interface Props {
  active: boolean
  size?: number           // 전체 SVG 크기 (px)
  strokeWidth?: number    // 선 두께 (px)
  className?: string
}

const AnswerCheck: React.FC<Props> = ({
  active,
  size = 40,
  strokeWidth = 6,
  className = ''
}) => {
  // 고유 ID 생성 (pattern collision 방지)
  const id = useId()
  // 반지름 = (전체 크기 - 선 두께) / 2
  const r = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * r

  // 애니메이션 Variants
  const draw: Variants = {
    hidden: { strokeDashoffset: circumference, opacity: 0 },
    visible: {
      strokeDashoffset: 0,
      opacity: 1,
      transition: {
        strokeDashoffset: { type: 'tween', duration: 0.3, ease: 'linear' },
        opacity: { duration: 0.3 },
      },
    },
  }

  return (
    <div className={className} style={{ width: size, height: size }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} fill="none">
        <defs>
          <pattern
            id={`${id}-pattern`}
            patternUnits="userSpaceOnUse"
            patternContentUnits="userSpaceOnUse"
            width={size}
            height={size}
          >
            <image
              href={pencilTex}
              x="0" y="0"
              width={size}
              height={size}
              preserveAspectRatio="none"
            />
          </pattern>
        </defs>

        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke={`url(#${id}-pattern)`}   // 패턴 아이디 참조
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          variants={draw}
          initial="hidden"
          animate={active ? 'visible' : 'hidden'}
          style={{
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
          }}
        />
      </svg>
    </div>
  )
}

export default AnswerCheck
